import React from "react"
import "./Footer.scss"
import { StaticImage } from "gatsby-plugin-image"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <a
          href="https://v4mirai.com/"
          className="footer-img"
          data-gtm-click="footer-logo"
        >
          <StaticImage src="../../images/footer-logo.png" alt="V4Mirai" />
        </a>
        <p className="copyright">© V4Mirai</p>
      </div>
    </footer>
  )
}

export default Footer
